'use strict';
angular.module('resCenRobotModule', ['resCenRobotRouterModule', 'resCenRobotLeftModule', 'robotQuickPreview'])
    .controller('resCenRobotCtrl', ['$scope', '$q', '$element', '$state', '$filter', '$stateParams', 'trsspliceString', 'modalDialog', 'trsHttpService', 'trsPrintService', 'storageListenerService', 'resCtrModalService', 'resourceCenterService',
        function($scope, $q, $element, $state, $filter, $stateParams, trsspliceString, modalDialog, trsHttpService, trsPrintService, storageListenerService, resCtrModalService, resourceCenterService) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                decode($stateParams.nodename); // 将路由上面的参数解码为汉字参数
                $scope.page = {
                    'CURRPAGE': 1,
                    'ITEMCOUNT': '',
                    'PAGECOUNT': '',
                    'PAGESIZE': 20,
                };
                $scope.jumpToPageNum = 1;
                $scope.status = {
                    currModule: 'jqrg',
                    batchOperateBtn: {
                        'hoverStatus': ''
                    }
                };
                $scope.params = {
                    'typeid': 'zyzx',
                    'serviceid': 'robotNews',
                    'modelid': 'summary',
                    'category': $scope.category,
                    'title': '',
                    'content': '',
                    'page': '1',
                    'pageSize': $scope.page.PAGESIZE
                };
                $scope.data = {
                    items: [],
                    selectedArray: [],
                    operFlags: []
                };
            }

            /**
             * [decode description] 将路由上面的参数解码为汉字参数
             * @param  {[type]} node [description]
             * @return {[type]}      [description]
             */
            function decode(nodename) {
                var reg = /[\u4e00-\u9fa5]+/;
                if (reg.test(nodename) || nodename == 'CPI' || nodename == 'GDP') {
                    $scope.category = nodename;
                } else {
                    nodename = decodeURI(nodename);
                    decode(nodename);
                }
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                listenStorage();
                initDropDown().then(function() {
                    if (angular.isDefined($scope.$root.filterDataBack)) { // 判断是否有传递的数据
                        /* $timeout(function() {*/
                        var filterDataBack = angular.copy($scope.$root.filterDataBack);
                        $scope.page = filterDataBack.page;

                        $scope.params.page = $scope.page.CURRPAGE;
                        $scope.params.pageSize = $scope.page.PAGESIZE;
                        $scope.keywords = filterDataBack.keywords;
                        $scope.params.title = filterDataBack.paramsTitle;
                        $scope.params.content = filterDataBack.paramsContent;
                        if (angular.isDefined(filterDataBack.fromdate)) { // 时间下拉选择
                            $scope.data.fromdate = filterDataBack.fromdate;
                            $scope.data.untildate = filterDataBack.untildate;
                            $scope.params.time = $scope.data.fromdate + ',' + $scope.data.untildate;
                        }
                        if (!!$scope.keywords) { // 当前检索词
                            if ($scope.params.title != '' && $scope.params.content != '') {
                                $scope.data.robotSelected = angular.copy($scope.data.robotAll[0]);
                            } else if ($scope.params.title != '') {
                                $scope.data.robotSelected = angular.copy($scope.data.robotAll[1]);
                            } else {
                                $scope.data.robotSelected = angular.copy($scope.data.robotAll[2]);
                            }
                        }
                        requestData();

                        /* }, 0);*/
                    } else {
                        requestData();
                    }
                });
                $scope.$on('$destroy', function() {
                    delete $scope.$root.filterDataBack;
                });
            }

            /**
             * [initDropDown description] 初始化搜索下拉框
             * @return {[type]} [description]
             */
            function initDropDown() {
                var deferred = $q.defer();
                $scope.data.robotAll = [{
                    name: '全部',
                    value: 'all'
                }, {
                    name: '标题',
                    value: 'title'
                }, {
                    name: '正文',
                    value: 'content'
                }];
                $scope.data.robotSelected = angular.copy($scope.data.robotAll[0]);
                deferred.resolve();
                return deferred.promise;
            }

            /**
             * [queryByDropdown description] test筛选条件触发后请求数据(时间下拉)
             * @param  {[type]} key   [description] 请求对象参数key
             * @param  {[type]} value [description] 请求对象值
             * @return {[type]}       [description] null
             */

            $scope.queryByDropdown = function(key, value) {
                $scope.params[key] = value;
                if (key == 'OperTime') {
                    $scope.params.time = $scope.data.fromdate + ',' + $scope.data.untildate;
                }
                $scope.data.items = [];
                $scope.keywords = ''; // 清空检索词
                $scope.params.title = $scope.params.content = '';
                requestData();
            };

            /**
             * [requestData description] 请求数据
             * @return {[type]} [description]
             */
            function requestData() {
                $scope.params.time = $scope.params.time == ',' ? '' : $scope.params.time;
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                    $scope.data.items = data.content;
                    $scope.page.ITEMCOUNT = data.summary_info.recordCount;
                    storageListenerService.previewPageTurningStorage($scope.data.items, 'nid', 'resourceDetail');
                    initOperFlag();
                });
            }

            /**
             * [showTitle description] 鼠标移上去后的标题显示
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.showTitle = function(item) {
                var title = item.DOCTITLE.replace(/\<\/?font(.*?)\>/g, '');
                return title;
            };

            /**
             * [showTime description] 调整时间的显示格式
             * @param  {[type]} item [description]
             * @return {[type]}      [description]
             */
            $scope.showTime = function(item) {
                var date = new Date(Date.parse(item.updatetime));
                return $filter('date')(date, 'yyyy-MM-dd HH:mm').toString();
            };

            /**
             * [initOperFlag description] 初始化取签见撤重
             */
            function initOperFlag() {
                var docIds = trsspliceString.spliceString($scope.data.items, 'nid', ',');
                if (docIds) {
                    var params = {
                        methodname: 'queryFlag',
                        serviceid: 'mlf_bigdataexchange',
                        guids: docIds
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        $scope.data.operFlags = [];
                        var temp = data;
                        for (var i in temp) {
                            if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf('1') > -1) {
                                $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                            }
                        }
                    });
                }
            }

            /**
             * [showOperFlag description] 显示取签见撤重标志
             * @param  {[type]} guid      [description]
             * @param  {[type]} flagIndex [description]
             * @return {[type]}           [description]
             */
            $scope.showOperFlag = function(guid, flagIndex) {
                var temp = queryItemBYGUID(guid);
                if (!!temp) {
                    return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == '1';
                } else {
                    return false;
                }
            };

            /**
             * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
             * @param  {[type]} guid [description]
             * @return {[type]}      [description]
             */
            function queryItemBYGUID(guid) {
                for (var i in $scope.data.operFlags) {
                    if (guid == $scope.data.operFlags[i].GUID) {
                        return $scope.data.operFlags[i];
                    }
                }
            }

            /**
             * @param  {[type]} ChnlDocId  [description] 取签见撤重 点击弹出
             * @param  {[type]} showRepeat [description]
             * @return {[type]}            [description]
             */
            $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick) {
                var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
                var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
            };

            /**
             * [listenStorage description] 监听本地缓存
             * @return {[promise]} [description] promise
             */
            function listenStorage() {
                storageListenerService.listenResource(function() {
                    requestData();
                    storageListenerService.removeListener('resource');
                }, $scope);
            }

            /**
             * [openTakeDraftModal description] 取稿
             * @return {[type]} [description]
             */
            $scope.openTakeDraftModal = function() {
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'fetch',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'nid', ','),
                    indexName: '',
                    channelName: $scope.status.currModule,
                    IsRobot: true
                };
                var isOnlyOne = !($scope.data.selectedArray.length > 1);
                var modalInstance = resCtrModalService.fullTakeDraft(params, isOnlyOne, $scope.data.selectedArray);
                modalInstance.result.then(function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        initOperFlag();
                        $scope.data.selectedArray = [];
                    });
                }, function() {

                    /* initOperFlag();
                    $scope.data.selectedArray = [];*/
                });
            };

            /**
             * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
             * @param  {[type]} data [description]
             * @return {[type]}      [description]
             */
            function takeDraftDownloadImgs(data) {
                var deferred = $q.defer();
                var needDownloadImg = false;
                for (var i = 0; i < data.REPORTS.length; i++) {
                    if (data.REPORTS[i].PICERROR == 1) {
                        needDownloadImg = true;
                        break;
                    }
                }
                if (needDownloadImg) {
                    resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                        deferred.resolve();
                    });
                } else {
                    deferred.resolve();
                }
                return deferred.promise;
            }

            /**
             * [CreationAxis description] 加入个人素材
             */
            /* $scope.CreationAxis = function() {
                var params = {
                    channelName: $scope.status.currModule,
                    indexName: "",
                    guid: trsspliceString.spliceString($scope.data.selectedArray, "nid", ","),
                    IsRobot: true
                };
                resourceCenterService.setBigDataCreation(params).then(function(data) {
                    modalDialog.alertType("添加成功", "", "success", false);
                    $scope.data.selectedArray = [];
                });
            };*/
            // 个人素材(稿件批量添加到个人素材)
            $scope.CreationAxis = function() {
                var params = {
                    typeid: 'zyzx',
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'batchPersonalMaterial',
                    channelName: $scope.status.currModule, // 栏目名称全拼结构
                    PersonalMaterialId: 0, // 所属文件夹ID，默认根节点（0）
                    indexName: '',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'nid', ','),
                    IsRobot: true // 机器人稿必传
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('添加成功', '', 'success', false, function() {
                        $scope.data.selectedArray = [];
                    });
                });
            };

            /**
             * [openReserveDraftModal description] 预留稿件
             * @return {[type]} [description]
             */
            $scope.openReserveDraftModal = function() {
                var selectedArray = $scope.data.selectedArray;
                if (selectedArray.length === 0) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false);
                    return;
                }
                var resCtrModalServiceModal = resCtrModalService.reserveDraft(selectedArray);
                resCtrModalServiceModal.result.then(function(result) {
                    delete result.items;
                    var params = {
                        serviceid: 'mlf_bigdataexchange',
                        methodname: 'delay',
                        guid: trsspliceString.spliceString($scope.data.selectedArray, 'nid', ','),
                        indexName: '',
                        channelName: $scope.status.currModule,
                        IsRobot: true
                    };
                    params = angular.extend(params, result);
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        modalDialog.alertType('预留成功!', '', 'success', false, function() {
                            initOperFlag();
                            $scope.data.selectedArray = [];
                        });
                    }, function() {
                        initOperFlag();
                        $scope.data.selectedArray = [];
                    });
                });
            };

            /**
             * [collect description] 收藏稿件
             * @return {[type]} [description]
             */
            $scope.collect = function() {
                var params = {
                    serviceid: 'mlf_bigdataexchange',
                    methodname: 'collect',
                    guid: trsspliceString.spliceString($scope.data.selectedArray, 'nid', ','),
                    indexName: '',
                    channelName: $scope.status.currModule,
                    IsRobot: true
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    modalDialog.alertType('收藏成功!', '', 'success', false, function() {
                        $scope.data.selectedArray = [];
                    });
                });
            };

            /**
             * [printBtn description] 打印稿件
             * @return {[type]} [description]
             */
            $scope.printBtn = function() {
                if ($scope.data.selectedArray.length === 0) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false);
                    return;
                }
                var params = {
                    'typeid': 'zyzx',
                    // "eventid": "rs",
                    'serviceid': 'robotNews',
                    'modelid': 'detail',
                    'nid': trsspliceString.spliceString($scope.data.selectedArray, 'nid', ','),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    trsPrintService.trsPrintRobot(data);
                    // $scope.data.selectedArray = [];
                });
            };

            /**
             * [export description] 导出稿件
             * @return {[type]} [description]
             */
            $scope.export = function() {
                if ($scope.data.selectedArray.length === 0) {
                    modalDialog.alertType('请先选择稿件！', '', 'warning', false);
                    return;
                }
                var params = {
                    serviceid: 'mlf_exportword',
                    methodname: 'exportBigDataDocs',
                    GUIDS: trsspliceString.spliceString($scope.data.selectedArray, 'nid', ','),
                    isRobot: true
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    window.open('/wcm/app/file/read_file.jsp?FileName=' + data);
                    $scope.data.selectedArray = [];
                });
            };

            /**
             * [getFilterTimeVal description]检索下拉框回调
             * @return {[type]} [description]
             */
            $scope.getFilterVal = function() {
                console.log($scope.data.robotSelected);
            };

            /**
             * [search description] 检索
             * @param  {[type]} ev [description]
             * @return {[type]}    [description]
             */
            $scope.search = function(ev) {
                if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                    if ($scope.data.robotSelected.value == 'title') {
                        $scope.params.title = $scope.keywords;
                        $scope.params.content = '';
                    } else if ($scope.data.robotSelected.value == 'content') {
                        $scope.params.title = '';
                        $scope.params.content = $scope.keywords;
                    } else {
                        $scope.params.title = $scope.keywords;
                        $scope.params.content = $scope.keywords;
                    }
                    $scope.page.CURRPAGE = $scope.jumpToPageNum = 1;
                    $scope.params.page = 1;
                    requestData();
                }
            };

            /**
             * [selectAll description] 全选
             * @return {[type]} [description]
             */
            $scope.selectAll = function() {
                $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            };

            /**
             * [selectDoc description] 多选
             * @return {[type]} [description]
             */
            $scope.selectDoc = function(item) {
                if ($scope.data.selectedArray.indexOf(item) < 0) {
                    $scope.data.selectedArray.push(item);
                } else {
                    $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
                }
            };

            /**
             * [selectPageNum description] 选择每页显示的数据数量
             * @return {[type]} [description]
             */
            /* $scope.selectPageNum = function() {
                $scope.jumpToPageNum = $scope.page.CURRPAGE = 1;
                $scope.params.page = 1;
                $scope.params.pageSize = $scope.page.PAGESIZE;
                requestData();
            };*/

            /**
             * [pageChanged description] 分页
             * @return {[type]} [description]
             */
            $scope.pageChanged = function() {
                $scope.params.page = $scope.page.CURRPAGE;
                $scope.jumpToPageNum = $scope.page.CURRPAGE;
                $scope.data.selectedArray = [];
                requestData();
                resourceCenterService.scrollTop($element);
            };

            /**
             * [jumpToPage description] 跳转
             * @return {[type]} [description]
             */
            /* $scope.jumpToPage = function() {
                if ($scope.jumpToPageNum > $scope.page.PAGECOUNT) {
                    $scope.jumpToPageNum = $scope.page.PAGECOUNT;
                }
                $scope.page.CURRPAGE = $scope.jumpToPageNum;
                $scope.params.page = $scope.jumpToPageNum;
                requestData();
            };*/
            /**
             * [quickPreview description] 快速预览模式
             * @return {[type]} [description]
             */
            $scope.quickPreview = function() {
                $scope.$root.filterData = {
                    page: $scope.page, // 分页
                    keywords: $scope.keywords, // 检索词
                    paramsTitle: $scope.params.title,
                    paramsContent: $scope.params.content,
                    fromdate: $scope.data.fromdate, // 开始时间
                    untildate: $scope.data.untildate, // 结束时间
                };
                $state.go('front.networksource.featuredresource.robot.quickpreview', $stateParams);
            };

            /**
             * [openPageForSearch description] 打开高级检索新页面
             * @return {[date]} [description]
             */
            $scope.openPageForSearch = function() {
                var url = $state.href('resadvancedsearch');
                window.open(url, '_blank');
            };
        }
    ]);
